import { IExpenseType, ISaveExpenseType, supportApi } from '../../shared';
import { NewBaseClient } from '../../shared/clients/new-base.client';

class ExpenseTypeClient extends NewBaseClient<ISaveExpenseType, IExpenseType> {
    constructor() {
        super(supportApi, '/expense-types');
    }
}

export const expenseTypeClient = new ExpenseTypeClient();
